'use strict';

(function () {
  'use strict';

  angular.module('translations').component('msSetLanguage', {
    templateUrl: 'translations/templates/set-language.html',
    controller: MsLanguageController,
    bindings: {
      headerLanguageSelector: '<'
    }
  });

  MsLanguageController.$inject = ['languageSvc', '$scope', '$rootScope', '$timeout', '$sessionStorage', 'focus', 'NotifyingSvc'];

  function MsLanguageController(languageSvc, $scope, $rootScope, $timeout, $sessionStorage, focus, NotifyingSvc) {
    var vm = this;
    vm.$onInit = init();
    vm.setLanguage = setLanguage;
    vm.getSelectedLanguage = getSelectedLanguage;
    vm.hasLanguageChanged = hasLanguageChanged;
    vm.getTranslationKey = getTranslationKey;
    vm.availableLanguages = [];
    vm.hasLanguageSwitched = false;

    languageSvc.getSupportedLanguages().then(function (availableLanguages) {
      vm.availableLanguages = availableLanguages;
    });

    vm.focusSelectBtn = function () {
      focus.byId('set-language-button', 500);
    };

    $scope.$watch('$root.selectedLanguage', function (newVal, oldVal) {
      vm.language = $rootScope.selectedLanguage;
      vm.hasLanguageSwitched = $sessionStorage.hasLanguageSwitched;
      vm.shouldReloadAgreements = newVal !== oldVal;

      if (vm.hasLanguageSwitched) {
        resetLanguageSwitchedState(vm.shouldReloadAgreements);
      }
    });

    function init() {
      vm.language = languageSvc.getLanguage();
    }

    function hasLanguageChanged() {
      return vm.language !== languageSvc.getLanguage();
    }

    function getSelectedLanguage(name) {
      var selectedLanguage = vm.availableLanguages.find(function (l) {
        return l.language === vm.language;
      });
      if (name) {
        return selectedLanguage.name;
      }
      return getTranslationKey(selectedLanguage);
    }

    function getTranslationKey(language) {
      var languageCode = language.language.replace('-', '');
      return 'vnext.languages.' + languageCode;
    }

    // 2000ms to let screen reader notice language change.
    function resetLanguageSwitchedState(shouldReloadAgreements) {
      $timeout(function () {
        delete $sessionStorage.hasLanguageSwitched;
        vm.hasLanguageSwitched = false;

        if (shouldReloadAgreements) {
          NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.GET_AGREEMENTS, true);
        }
      }, 2000);
    }

    function setLanguage() {
      $sessionStorage.hasLanguageSwitched = true;
      languageSvc.setLanguage(vm.language, true);
    }
  }
})();